import ImagestackIcon from '@shared/assets/icons/v2/imagestack.svg';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIcon } from '@shared/components/image';
import { Colors, fadeIn } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import classNames from './overlay.module.css';

interface FileDropListenerOverlayProps {
  /**
   * What the overlay says while a file is held over the target.
   *
   * Defaults to attaching, which is what a drop does nearly everywhere. A surface where it does
   * something else passes its own line, rather than building a second overlay that has to be kept
   * looking like this one.
   */
  message?: string;
}

export function FileDropListenerOverlay({ message }: FileDropListenerOverlayProps) {
  return (
    <View className={[classNames.fileDropListenerOverlay, fadeIn]}>
      <View className={classNames.content}>
        <MBIcon noPadding color={Colors.v2.purple} source={ImagestackIcon} />
        <Text weight="bold">{message ?? i18n('form.dragAndDropToAttach')}</Text>
      </View>
      <View className={classNames.border} />
    </View>
  );
}
